import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import ProductCategory, { Props } from './ProductCategory';
import { addCartItem, evaluateCartPrice } from '../../actions/cart';

function mapDispatchToProps(dispatch: Dispatch): Pick<Props, 'addCart'> {
  return {
    addCart(id: number): void {
      dispatch(addCartItem(id));
      // @ts-ignore missing cart actions typing yet
      dispatch(evaluateCartPrice());
    },
  };
}

export default connect(null, mapDispatchToProps)(ProductCategory);
